<div class="igntr-theme bg-[--background-color]">
  <div
    class="max-w-[1180px] mx-auto px-[16px] py-[16px] md:px-[40px] md:py-[24px] pb-12"
  >
    <app-page-hero
      [title]="'tenants'"
      [description]="
        allTenants.length +
        ' ' +
        ('workspaces' | transloco) +
        ' · ' +
        totalUsers +
        ' ' +
        ('usersTotal' | transloco)
      "
    >
      <div class="flex items-center gap-3">
        <div class="inline-flex rounded-lg border border-slate-200 bg-white p-0.5">
          <button
            type="button"
            class="px-2 py-1 rounded-md inline-flex items-center text-slate-500 hover:text-slate-800 transition-colors"
            [ngClass]="
              viewMode === 'list'
                ? 'bg-[var(--primary-color)] !text-white'
                : ''
            "
            (click)="viewMode = 'list'"
          >
            <igntr-icon name="list"></igntr-icon></button
          ><button
            type="button"
            class="px-2 py-1 rounded-md inline-flex items-center text-slate-500 hover:text-slate-800 transition-colors"
            [ngClass]="
              viewMode === 'grid'
                ? 'bg-[var(--primary-color)] !text-white'
                : ''
            "
            (click)="viewMode = 'grid'"
          >
            <igntr-icon name="grid"></igntr-icon>
          </button>
        </div>
        <button
          [routerLink]="['/tenants/new']"
          class="px-3.5 py-2 rounded-lg bg-[var(--primary-color)] text-white text-[14px] font-medium hover:!brightness-110 items-center gap-1.5 shadow-[0_1px_0_rgba(255,255,255,.2)_inset,0_4px_12px_-4px_var(--primary-color)] hidden sm:inline-flex"
        >
          <igntr-icon name="plus"></igntr-icon>
          {{ "newTenant" | transloco }}
        </button>
      </div>
    </app-page-hero>

    <app-spinner *ngIf="repo.isLoading$ | async"></app-spinner>
    <app-tenant-list
      *ngIf="!(repo.isLoading$ | async)"
      style="width: 100%"
      [innerWidth]="innerWidth"
      [viewMode]="viewMode"
      [tenants]="filteredTenants"
      [isDeleteDisabled]="
        !(auth.isSuperAdmin$ | async) && !(auth.isPartnerManager$ | async)
      "
      (delete)="delete($event)"
      (clone)="handleCloneClick($event); (refreshData)"
    ></app-tenant-list>

    <div
      class="flex items-center justify-between mt-6 text-[14px] !text-slate-500"
      *ngIf="allTenants.length >= 0"
    >
      <div class="font-mono tabular-nums">
        Showing {{ allTenants.length }} of {{ allTenants.length }}
      </div>
      <div class="flex items-center gap-1">
        <button class="px-2 py-1 rounded-md hover:bg-slate-100">‹</button
        ><span class="font-mono tabular-nums px-1">1 / 1</span
        ><button class="px-2 py-1 rounded-md hover:bg-slate-100">›</button>
      </div>
    </div>
  </div>
</div>

<p-button
  class="flex sm:hidden mobile-add-button"
  icon="pi pi-plus"
  [routerLink]="['/tenants/new']"
/>
